export const CopyHook = {
  text: undefined,
  tooltipFeedbackText: undefined,

  mounted() {
    this.text = this.el.dataset.text;
    this.tooltipFeedbackText = this.el.dataset.tooltipFeedbackText;

    this.el.addEventListener("click", (e) => {
      navigator.clipboard.writeText(this.text);

      let icon;
      if (e.target.tagName === "I") {
        icon = e.target;
      } else {
        icon = e.target.querySelector(":scope i");
      }
      icon.classList.replace("fa-copy", "fa-check");
      icon.classList.add("text-success");

      const tooltip = e.target.parentElement.querySelector(".tooltip-text");
      if (tooltip) {
        tooltip.innerText = this.tooltipFeedbackText;
      }
    });
  },

  updated() {
    this.text = this.el.dataset.text;
    this.tooltipFeedbackText = this.el.dataset.tooltipFeedbackText;
  },
};
